<section class="parker-banner">
  <app-mini-env-banner [slides]="bannerSlides"
    (butonAction)="buttonAction($event)"  ></app-mini-env-banner>

  <div class="d-flex align-items-center parker-img-row">
    <div class="d-flex align-items-center" style="gap: 10px;">
      <span class="brought-to">Brought to you in collaboration with</span>
    </div>
    <div>
      <div class="d-flex">
        <div>
          <img [src]="'assets/tenant-assets/images/wow-logo-white.svg'" alt="" class="image-box">
        </div>
      </div>
    </div>
  </div>
</section>


<section class="container-fluid discount-section">
  <div class="container">

    <app-mini-env-heading-block 
      class="medication-heading"
      [miniTitle]="'Easy Medicine Access'" [title]="'Fast & Simple Medication Access'"
      [description]="'Access the medications you need without long waits. Simple ordering and trusted delivery you can count on.'"
      [style]="'max-width: 703px;'" [discription]="'max-width: 541px;font-size : 18px ;'"></app-mini-env-heading-block>

    <div class="row" style="row-gap: 15px;margin-top: 30px;">
      <app-mini-env-content-box [imgSrc]="imgSrc">
        <h2 class="content-heading">Pharmacy Services</h2>
        <p class="content-txt">
          Enjoy convenient and cost-effective pharmacy options, designed to make healthcare more accessible when it
          matters most.
        </p>

        <ul class="d-flex content-list">
          <div class="list-item"><img [src]="sharedService.imagesUrl + 'black-circle-tick.svg'" alt="">
            <p>
              <span class="bullet-heading">Free Generic Medicine : </span>
              Get 93% of prescriptions at no cost, with
              home delivery for chronic care & local pickup for acute care.
            </p>
          </div>
          <div class="list-item"><img [src]="sharedService.imagesUrl + 'black-circle-tick.svg'" alt="">
            <p>
              <span class="bullet-heading">Local Pharmacy Access : </span>
              Pick up all medications at discounted rates from over 70,000 local pharmacies.
            </p>
          </div>
          <div class="list-item"><img [src]="sharedService.imagesUrl + 'black-circle-tick.svg'" alt="">
            <p>
              <span class="bullet-heading">Discounted Brand Medication : </span>
              Get brand-name medications at significant discounts from Tier-1 countries (UK, Canada, Australia, New
              Zealand) with free home delivery.
            </p>
          </div>
        </ul>

        <p class="bullet-heading mt-2 ml-0">
          Note:
        </p>
        <p class="note-txt">
          **Log in to your account during your doctor visit to view and direct prescriptions. Chronic meds are
          e-prescribed to Manifest Pharmacy in Greer, SC for home delivery, while acute meds are sent to local
          pharmacies (CVS, Walgreens, Walmart) for pickup.
        </p>
      </app-mini-env-content-box>
    </div>
  </div>
</section>

<section class="container-fluid bg-white avail-benefits">

  <app-mini-env-heading-block
    [miniTitle]="('BENIFITSMEMBERSHIP.MINI_TITLE' | translateIt: {language: sharedService.currentLanguage} | async)"
    [title]="'Your Care, Step by Step'"
    [description]="'We’ve streamlined the process so you don’t have to think twice. From start to finish, everything is designed to be quick and easy.'"
    [style]="'max-width: 738px;'"></app-mini-env-heading-block>

  <app-imagebox-bullet-scroll [imgLink]="'assets/tenant-assets/mini-env/images/smiling-woman.svg'"
    [steps]="steps"></app-imagebox-bullet-scroll>
</section>

<section>
  <div class="container-fluid search-section">
    <div class="container content-box">
      <div class="search-text-box">
        <app-mini-env-heading-block [miniTitle]="'Search your Medication'" [title]="'Click to Search Your Medications'"
          [description]="'We have all major medications available either free or at dicounted prices. Search for yours below!'"
          [leftAlign]="true"></app-mini-env-heading-block>
        <app-search-input
        [medicine]="'Quick search for popular medications:'"
        [search1]="' Aspirin,'"
        [search2]="'Ibuprofen,'"
        [zipCodePlaceholder]="'48243'"
        [search3]="'Amoxicillin'"
          [keywordplaceholder]="('SEARCH.INPUT.PLACEHOLDER' | translateIt: {language: sharedService.currentLanguage} | async)"
          [noData]="noData" (searchAction)=" sharedService.routeToSearch()" (searchChange)="getMedicines($event)"
          [isLoading]="isLoading" [showSearchIconLeft]='false' [showSearchText]="false" [backgroundColor]="'white'"
          [locationIcon]="'icons/location-blue.svg'">
          <div *ngIf="sharedService.results.length != 0" class="results">
            @for (item of sharedService.results; track $index) {
            <div class="listing-item" (click)="sharedService.selectPharmacy(item)">
              <div class="content">
                <p class="text">{{item.drugName}}</p>
                @if(item.drugType == "Complete_Care" || item.drugType == "Formulary" || item.drugType == "Acute" || item.drugType == "Acute_only"){
                <p class="free">Free</p>
                }
              </div>
            </div>
            }
          </div>

        </app-search-input>
      </div>
      <div class="image-container">
        <img class="man-reading-image img-fluid" [src]="IMAGES_URL + 'man-reading.svg'" />
      </div>
    </div>
  </div>
</section>


<!-- <section>
  <div class="container-fluid video-section">

    <app-mini-env-heading-block [miniTitle]="'See WoW Health in Action'" [title]="'A Sneak Peek Inside WoW Health'"
      [description]="'Step inside WoW Health and see what makes us different. Thoughtfully designed to support your health journey every step of the way.'"
      [style]="'max-width: 749px;'"></app-mini-env-heading-block>

    <div class="container">
      <app-video-player></app-video-player>
    </div>
  </div>
</section> -->

<section class="container-fluid login-section">
  <app-mini-env-heading-block class="your-medication" [title]="'Your Medications Just Got Simplified!'"
    [description]="'Skip the pharmacy lines, and start today with the easy and affordable medications in a few clicks'"
    [style]="'max-width: 749px;'"></app-mini-env-heading-block>
    <button (click)="login()" class="login-btn-redirect">Log In to Get Started</button>
</section>

<section class="container-fluid faq-section">
  <div class="container">

    <app-mini-env-heading-block [miniTitle]="'FAQs'" [title]="'Frequently Asked Questions'"
      [description]="'Need help? Our dedicated customer support team is available 24/7 to answer your questions and provide assistance. Call us anytime at 844-969-4325.'"
      [style]="'max-width: 684px;'"></app-mini-env-heading-block>

    <div class="mt-30">
      <app-mini-env-faqs [faqData]="faqList"></app-mini-env-faqs>
    </div>
  </div>
</section>

<!-- <section class="container-fluid footer-section">
   <app-mini-env-sub-footer></app-mini-env-sub-footer>
</section> -->
<!--  How can we help Section End-->